export default "__VITE_ASSET__W58mEDTG__"